// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-main-div-search {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.Input-headingcontainer-search {
  margin-bottom: 5px;
}

.input-div-search {
  font-weight: bold;
}

.search-input-container-search {
  position: relative;
  overflow: visible;
}
.search-icon-search {
  position: absolute;
  top: 50%;
  width: 16px;
  height: 16px;
  color: #405261;
  right: 17px;
  transform: translateY(-50%);
  overflow: visible;
  pointer-events: none;
}

.input-new-search {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 13px 35px 13px 16px;
  outline: none;
}

.InputErrorMsg-search {
  color: red;
  margin-top: 5px;
}
.input-new-search:hover {
  border-color: #a9b0b6;
}

.input-new-search:focus {
  border-color: #148dfd;
  box-shadow: 0 0 2px #148dfd;
}
.input-new-search::placeholder {
  color: #c5ced6;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: "Inter", sans-serif !important;
}

.input-new-search::-webkit-input-placeholder {
  /* Chrome, Safari */
  color: #c5ced6;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: "Inter", sans-serif !important;
}

.input-new-search::-moz-placeholder {
  /* Firefox */
  color: #c5ced6;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: "Inter", sans-serif !important;
}

.input-new-search:-ms-input-placeholder {
  /* IE, Edge */
  color: #c5ced6;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: "Inter", sans-serif !important;
}
.password-field {
  position: relative;
}

.input-wrapper {
  display: flex;
  align-items: center;
}

input {
  padding-right: 2.5rem;
}
.input-wrapper-password {
  display: flex;
  align-items: center;
  position: relative;
}
.password-toggle {
  position: absolute;
  right: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/newstyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".input-main-div-search {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.Input-headingcontainer-search {\n  margin-bottom: 5px;\n}\n\n.input-div-search {\n  font-weight: bold;\n}\n\n.search-input-container-search {\n  position: relative;\n  overflow: visible;\n}\n.search-icon-search {\n  position: absolute;\n  top: 50%;\n  width: 16px;\n  height: 16px;\n  color: #405261;\n  right: 17px;\n  transform: translateY(-50%);\n  overflow: visible;\n  pointer-events: none;\n}\n\n.input-new-search {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 13px 35px 13px 16px;\n  outline: none;\n}\n\n.InputErrorMsg-search {\n  color: red;\n  margin-top: 5px;\n}\n.input-new-search:hover {\n  border-color: #a9b0b6;\n}\n\n.input-new-search:focus {\n  border-color: #148dfd;\n  box-shadow: 0 0 2px #148dfd;\n}\n.input-new-search::placeholder {\n  color: #c5ced6;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: \"Inter\", sans-serif !important;\n}\n\n.input-new-search::-webkit-input-placeholder {\n  /* Chrome, Safari */\n  color: #c5ced6;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: \"Inter\", sans-serif !important;\n}\n\n.input-new-search::-moz-placeholder {\n  /* Firefox */\n  color: #c5ced6;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: \"Inter\", sans-serif !important;\n}\n\n.input-new-search:-ms-input-placeholder {\n  /* IE, Edge */\n  color: #c5ced6;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: \"Inter\", sans-serif !important;\n}\n.password-field {\n  position: relative;\n}\n\n.input-wrapper {\n  display: flex;\n  align-items: center;\n}\n\ninput {\n  padding-right: 2.5rem;\n}\n.input-wrapper-password {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.password-toggle {\n  position: absolute;\n  right: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
